module.exports = __webpack_public_path__ + "img/file.52de119b.svg";